<template>

</template>

<script>
export default {
    data: function () {
        return {
            modalName: '',
            maxInnerHeight: 0,
            maxBodyHeight: 0,
            visible: false,
        }
    },
    methods: {
        calcModalHeight: function () {
            if(!this.visible) {
                return;
            }

            let height = 600;
            let appEl = document.getElementById("app");
            if(appEl) {
                height = Math.max(height, appEl.clientHeight);
            }
            let dialog = this.$el.getElementsByClassName("modal-dialog")[0];
            if(dialog) {
                let style = window.getComputedStyle(dialog);
                height = height - parseInt(style.marginTop) - parseInt(style.marginBottom);
            }
            let header = this.$el.getElementsByClassName("modal-header")[0];
            if(header) {
                height = height - header.clientHeight;
            }
            let errors = this.$el.getElementsByClassName("modal-errors")[0];
            if(errors) {
                let style = window.getComputedStyle(errors);
                height = height - errors.clientHeight - parseInt(style.marginBottom) - parseInt(style.borderTop) - parseInt(style.borderBottom);
            }
            let fixedRow = this.$el.getElementsByClassName("modal-fixed-row")[0];
            if(fixedRow) {
                height = height - fixedRow.clientHeight;
            }
            let footer = this.$el.getElementsByClassName("modal-footer")[0];
            if(footer) {
                height = height - footer.clientHeight;
            }
            let footerApp = document.getElementById("app-footer");
            if(footerApp) {
                height = height - footerApp.clientHeight;
            }
            let heightBody = height;
            let body = this.$el.getElementsByClassName("modal-body")[0];
            if(body) {
                let style = window.getComputedStyle(body);
                height = height - parseInt(style.paddingTop) - parseInt(style.paddingBottom);
            }
            this.maxInnerHeight = height;
            this.maxBodyHeight = heightBody;
        },
    },
    mounted() {
        EaseEventBus.listen('showModal', (modal) => {
            if (modal === this.modalName) {
                this.visible = true;
                this.$nextTick(() => {
                    this.calcModalHeight();
                });
            }
        });

        EaseEventBus.listen('hideModal', (modal) => {
            if (modal === this.modalName) {
                this.visible = false;
            }
        });

        this.$nextTick(() => {
            window.addEventListener('resize', this.calcModalHeight);
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calcModalHeight);
    }
}
</script>
